import z from 'zod';
import { IsoDateCodec } from '@/pages/OperationsAdministration/types/Api/IsoDateCodec';
import { WorkstreamDefinitionSourceFeedMetadataSchema } from '@/pages/OperationsAdministration/types/Api/WorkstreamDefinitionSourceFeedMetadata';
import { WorkstreamDefinitionAdvancedSnapshotSchema } from '@/pages/OperationsAdministration/types/Api/WorkstreamDefinitionAdvancedSnapshot';
import { WorkstreamDefinitionUserSchema } from '@/pages/OperationsAdministration/types/Api/WorkstreamDefinitionUser';

export const WorkstreamDefinitionOperationConfigSchema = z.object({
    workstreamDefinitionId: z.number(),
    name: z.string(),
    timezone: z.string(),
    backlogEffectiveFrom: z.optional(IsoDateCodec),
    lastUpdatedBy: z.optional(WorkstreamDefinitionUserSchema),
    advancedSnapshot: z.optional(WorkstreamDefinitionAdvancedSnapshotSchema),
    sourceFeedMetadata: z.optional(WorkstreamDefinitionSourceFeedMetadataSchema)
});
export type WorkstreamDefinitionOperationConfig = z.infer<typeof WorkstreamDefinitionOperationConfigSchema>;

export const WorkstreamDefinitionOperationConfigResponseSchema = z.array(WorkstreamDefinitionOperationConfigSchema);
export type WorkstreamDefinitionOperationConfigResponse = z.infer<
    typeof WorkstreamDefinitionOperationConfigResponseSchema
>;
